















































































import PageHeader from "@/components/PageHeader.vue";
import { Vue, Component, Watch } from "vue-property-decorator";
import { Action, State, Getter } from "vuex-class";
import moment from "moment";
import { duration, objectify } from "@/helpers";
import { capitalize } from "lodash";
import Callback from "@/components/Call/Callback.vue";
import * as api from "@/lib/api";
import LeadPanel from "@/components/Lead/LeadPanel.vue";
import { User } from "@/types";
import { getUserId } from "@/helpers";
import { collections } from "@/configs/firebase";
import logger from "../configs/logger";
import { Routes } from "@/router/routes";

@Component({ components: { PageHeader, LeadPanel, Callback } })
export default class CallHistory extends Vue {
  @Action("getCallHistory") getCallHistory!: Function;
  @Action("getLead") getLead!: Function;
  @State("user") user!: User;
  @State("inCallMode") inCallMode!: boolean;

  activeLeadId: string = "";
  loading = false;
  dialog = false;
  search = "";
  callHistory = [];
  headers = [
    {
      text: "Time",
      align: "start",
      sortable: true,
      value: "time",
      width: 170
    },
    { text: "Duration", value: "duration" },
    { text: "Lead Name", value: "leadName", width: 150 },
    { text: "Transfer From", value: "transferFrom" },
    { text: "Disposition", value: "disposition" },
    { text: "Group", value: "group" },
    { text: "Call Source", value: "callSource" },
    { text: "Tack Creation Source", value: "taskCreationSource", width: 170 },
    { text: "Lead Source", value: "leadSource" },
    { text: "Call Back", value: "callback" },
    { text: "View Lead", value: "view" }
  ];
  adminHeaders = [
    { text: "Task Id", value: "taskId" },
    { text: "Conference Id", value: "conferenceId" }
  ];

  @Watch("inCallMode")
  onCallModeChange(val: any, preVal: any) {
    if (val) this.dialog = false;
  }

  get isAdmin() {
    return this.user.roles && this.user.roles.includes("admin");
  }

  mounted() {
    if (this.isAdmin) {
      this.headers = [...this.adminHeaders, ...this.headers];
    }
    this.$nextTick(this.loadHistory);
  }

  openLookup() {
    this.$router.push({ name: Routes.LookupLead });
  }

  async handleViewLead(leadId: string) {
    this.activeLeadId = leadId;
    this.dialog = true;
  }

  async loadHistory() {
    this.loading = true;
    const res = await this.getCallHistory(getUserId(this.user), 40);
    this.callHistory = res.map((item: any) => ({
      taskId: item.task_sid,
      conferenceId: item.conference_sid,
      time: moment
        .unix(item.created_ts ? item.created_ts.seconds : 0)
        // @ts-ignore
        .tz("America/New_York")
        .format("MM D YY, h:mm:ss a"),
      duration: this.getDuration(
        item.created_ts ? item.created_ts.seconds : 0,
        item.call_ended_ts ? item.call_ended_ts.seconds : 0
      ),
      leadName: item.lead_name,
      disposition: item.disposition,
      leadSource: item.lead_source,
      callSource: item.call_source,
      taskCreationSource: capitalize(
        item.task_creation_source.replace(/_/g, " ")
      ),
      transferFrom: item.transfer_from_user_email,
      group: capitalize(item.requested_group),
      callback: {
        leadKey: item.lead_key,
        workerSid: this.user.worker_sid,
        taskAttributeKey: `task_attribute/${item.id}`
      },
      view: { leadId: item.lead_key.split("/")[1] }
    }));
    this.loading = false;
  }

  getDuration(startSec: number, endSec: number) {
    const start = moment.unix(startSec);
    const end = moment.unix(endSec);
    const secs = end.diff(start, "seconds");
    return duration(secs);
  }
}
